import UserBadge from './UserBadge';

export default UserBadge;
